require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./contacts-san-francisco.json") })
        }
      }, "path---contacts-san-francisco");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---contacts-san-francisco!./.cache/json/contacts-san-francisco.json
// module id = 1400
// module chunks = 231608221292675